define(["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var $iframesWithDataSrcAttribut = "iframe[data-src]";
        var lazysizesIndicatorClass = "lazyload";
        $($iframesWithDataSrcAttribut).addClass(lazysizesIndicatorClass);
    });
});
